import { Col, Container, Row, Button } from 'reactstrap';
import {
  SystemOfMeasuresEnum,
  callNativeAppRemoveLastRoute,
  useToast,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import { useTranslator, withLoading } from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import TitleBar from '../../Layout/TitleBar';
import MeasurementForm from '../Form/MeasurementForm';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { saveMeasurementsArgType } from '../types';

interface IAddEditMeasurementContainer {
  saveMeasurements: (formData: saveMeasurementsArgType) => {
    goalLostBecauseOfLoseWeight: boolean;
    goalLostBecauseOfPutOnWeight: boolean;
    goalReachedBecauseOfLoseWeight: boolean;
    goalReachedBecauseOfPutOnWeight: boolean;
    code: number;
  };
  deleteMeasurements: () => { data: any };
  measurements: {
    weight: number;
    hip: number;
    waist: number;
    thigh: number;
    rightthigh: number;
    arm: number;
    rightarm: number;
    chest: number;
  };
  date: string;
  systemOfMeasures: SystemOfMeasuresEnum;
  availableMeasurements: string[][];
}

const AddEditMeasurementContainer: React.FC<IAddEditMeasurementContainer> = ({
  saveMeasurements,
  deleteMeasurements,
  measurements,
  date,
  systemOfMeasures,
  availableMeasurements,
}) => {
  const { t } = useTranslator();
  const navigate = useNavigate();
  const { toastError } = useToast();

  const handleDelete = async () => {
    const response = await deleteMeasurements();

    if (response.data.me.measurementGroupDelete.code === 422) {
      toastError(response.data.me.measurementGroupDelete.details[0].messages[0]);
    }
    navigate(-1);
    callNativeAppRemoveLastRoute();
  };

  return (
    <Layout>
      <TitleBar level={2}>{t('editMeasurements.navbarTitle')}</TitleBar>
      <section className="page-template-measurements full-height3a">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }} xl={{ size: 6, offset: 3 }}>
              <div className="page-container">
                <div className="measurements-container">
                  <MeasurementForm
                    saveMeasurements={saveMeasurements}
                    systemOfMeasures={systemOfMeasures}
                    measurements={measurements}
                    date={date}
                    availableMeasurements={availableMeasurements}
                    key={date}
                  />

                  <div className="text-center mt-xl">
                    <Button color="link" size="sm" onClick={handleDelete}>
                      {t('measurements.deleteCurrentMeasurementButton')}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
};

export default withLoading(AddEditMeasurementContainer, UniversalPlaceholder);
